import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../utils/auth';
import { motion } from 'framer-motion';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);

      // Copy token to clipboard
      const token = localStorage.getItem('token');
      if (token) {
        await navigator.clipboard.writeText(token);
        console.log('Token copied to clipboard!');
        // Optional: toast or alert to notify
        alert("✅ Login Success! Now click 'Login' in the Neo Typer app.");
      }

      navigate('/dashboard');
    } catch {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.backgroundImage}></div>
      <div style={styles.overlay}></div>

      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        style={styles.card}
      >
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          style={styles.title}
        >
          Neo<span style={{ color: '#16f288' }}>Typer</span>
        </motion.h1>

        <p style={styles.subtext}>Enter the future of auto-typing</p>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={styles.inputGroup}>
            <label>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />
          </div>
          <div style={styles.inputGroup}>
            <label>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.05, boxShadow: '0 0 20px #16f28888' }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            style={styles.button}
          >
            Enter Dashboard
          </motion.button>
        </form>

        <p style={{ marginTop: 20, fontSize: 14, color: '#aaa' }}>
          New here? <Link to="/signup" style={styles.link}>Create an account</Link>
        </p>

        {error && <p style={styles.error}>{error}</p>}
      </motion.div>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    height: '100vh',
    width: '100%',
    fontFamily: "'Space Grotesk', sans-serif",
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backgroundImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: 'url("https://wallpapers.com/images/hd/coding-background-9izlympnd0ovmpli.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: -2,
  },
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(135deg, rgba(10,10,20,0.8), rgba(20,30,40,0.85))',
    zIndex: -1,
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    padding: '50px 40px',
    borderRadius: '24px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
    backdropFilter: 'blur(14px)',
    border: '1px solid rgba(255,255,255,0.1)',
    width: '90%',
    maxWidth: 400,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: '2.4rem',
    fontWeight: 700,
    marginBottom: 6,
    letterSpacing: 1.2,
  },
  subtext: {
    color: '#aaa',
    fontSize: 14,
    marginBottom: 30,
  },
  inputGroup: {
    width: '100%',
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    color: '#ccc',
  },
  input: {
    marginTop: 6,
    padding: '12px 16px',
    backgroundColor: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 12,
    color: '#fff',
    fontSize: 16,
    outline: 'none',
    transition: 'all 0.3s ease',
  },
  button: {
    marginTop: 10,
    width: '100%',
    padding: '14px 0',
    borderRadius: 12,
    background: '#16f288',
    border: 'none',
    fontWeight: 600,
    color: '#000',
    fontSize: 16,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  link: {
    color: '#16f288',
    textDecoration: 'none',
  },
  error: {
    color: 'red',
    fontSize: 13,
    marginTop: 10,
    textAlign: 'center',
  },
};
